export const DISPLAYABLE_SALARY_UNITS = [
  "year",
  "month",
  "week",
  "day",
  "hour",
] as const;

export type DisplayableSalaryUnit = (typeof DISPLAYABLE_SALARY_UNITS)[number];

export const getDisplayableSalaryUnit = (
  value?: string | null,
): DisplayableSalaryUnit | undefined => {
  const normalized = value?.trim().toLowerCase();
  return DISPLAYABLE_SALARY_UNITS.find((unit) => unit === normalized);
};
